module.exports = __webpack_public_path__ + "static/media/2_bill_grin.fd7460e7.svg";